export default {
  styleOverrides: {
    root: {
      minHeight: '56px !important',
      width: '100% !important',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.87)',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '2px',
      }
    },
    input: {
      padding: '16.5px 14px !important',
      fontSize: '1rem',
      lineHeight: '1.4375em',
      width: '100% !important',
      boxSizing: 'border-box'
    }
  }
};
